import { render, staticRenderFns } from "./LevelCatalogue.vue?vue&type=template&id=974bf21c&"
import script from "./LevelCatalogue.vue?vue&type=script&lang=js&"
export * from "./LevelCatalogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports